"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesClient = exports.Configuration = exports.featuresClient = exports.init = void 0;
const client_1 = require("./client/client");
Object.defineProperty(exports, "FeaturesClient", { enumerable: true, get: function () { return client_1.FeaturesClient; } });
const configuration_1 = require("./client/configuration");
Object.defineProperty(exports, "Configuration", { enumerable: true, get: function () { return configuration_1.Configuration; } });
const service_1 = require("./client/cache/service");
const axios_1 = __importDefault(require("axios"));
let featuresClient;
exports.featuresClient = featuresClient;
/**
 * Initializes once thew FeatureClient, given a configuration
 * and an array of EvaluationCriteria.
 *
 * This initializer also creates the HttpClient that will be
 * used by the SDK to fetch data.
 *
 * @param configuration The client configuration
 * @param features The optional Features to automatically load the assignments for.
 */
const init = (configuration, features) => {
    if (!featuresClient) {
        const httpClient = axios_1.default.create({
            baseURL: configuration.baseUrl,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const serviceCache = new service_1.ServiceClientCache(configuration.cacheMaxSize, configuration.cacheTTLInSeconds);
        exports.featuresClient = featuresClient = new client_1.FeaturesClient(httpClient, serviceCache, configuration.assignmentListener, configuration.defaultTargetedRuntime, features, configuration.hydrateTargetingProperties);
    }
    return featuresClient;
};
exports.init = init;
__exportStar(require("./client/models"), exports);
